import './styles.scss';

const PictureComponent = ({ srcBig, srcSmall = '', alt = '', className = '' }) => (
    <picture className={`picture-component`}>
        {srcSmall && <source srcSet={srcSmall} media="(max-width: 1024px)" />}
        <img src={srcBig} alt={alt} className={`${className}`} />
    </picture>
);

export default PictureComponent;
